import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-custom-packaging-metrics',
  templateUrl: './custom-packaging-metrics.component.html',
  styleUrls: ['./custom-packaging-metrics.component.css'],
})
export class CustomPackagingMetricsComponent {
  modalLabel: any;
  submitted = false;
  @Output() savePackagingMetricsEvent = new EventEmitter<any>();
  packagingMetricsData: any;
  packagingMetricsEditForm!: FormGroup;
  metricList: any;
  selectedMetrics: any;
  packagingMetricIds: any;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private cookieService: CookieService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.packagingMetricsData =
      this.modal?.modalService?.config?.initialState?.['packagingMetricsData'];
    this.metricList = this.packagingMetricsData.packagingMetricsItems;
  }

  ngOnInit(): void {
    this.packagingMetricsEditForm = this.formBuilder.group({
      indicators: [this.packagingMetricsData.packagingIds || null, [Validators.required]],
    });
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    this.packagingMetricIds = this.selectedMetrics.map((data: any) => {
      return data.id;
    });
    const data = {
      organizationId: Number(this.cookieService.get('organizationId')),
      packagingIds: this.packagingMetricIds,
    };
    this.savePackagingMetricsEvent.emit(data);
  }

  selectProduct(event: any) {
    this.selectedMetrics = event;
  }
}
